module.exports = __webpack_public_path__ + "static/media/communication.c8db2c44.svg";